import React, {useRef, useState} from "react";
import {apiPost, apiSetAccessToken} from "../api";
import TextValidator from "./TextValidator";
import {ValidatorForm} from "react-form-validator-core";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import uuid4 from "uuid4";
import {useCurrentState} from "../globalState";

let clearer = null;

function LoginForm(props) {
    let [user, setUser] = useCurrentState("user");
    let [title, setTitle] = useCurrentState("title");
    let [userAccessToken, setUserAccessToken] = useCurrentState("userAccessToken");
    let [email, setEmail] = useState("");
    let [password, setPassword] = useState("");
    let [error, setError] = useState(false);
    let [errorText, setErrorText] = useState("");
    let [loading, setLoading] = useState(false);
    const inputRef = useRef(null);

    setTitle("Login");

    let submit = async () => {
        setLoading(true);
        setError(false);
        let res = null;
        try {
            res = await apiPost("login", {
                email: email,
                password: password,
                device_id: uuid4()
            });
            apiSetAccessToken(res.data.access_token);
            setUserAccessToken(res.data.access_token);
            window.localStorage.setItem("user_access_token", res.data.access_token);
            setUser(res.data.user);
            window.location.href = "/";
        } catch (e) {
            setError(true);
            setErrorText("incorrect password!");
            clearTimeout(clearer);
            clearer = setTimeout(() => {
                setErrorText("");
            }, 5000);
        } finally {
            setLoading(false);
        }
    };


    return <div style={{margin: 16}}><Card>
        <CardContent>
            <div>
                <ValidatorForm ref={inputRef} onSubmit={submit} noValidate autoComplete="off">
                    <div>
                        <TextValidator
                            error={error}
                            fullWidth
                            disabled={loading}
                            id="outlined-email"
                            label="E-mail"
                            validators={['required', 'isEmail']}
                            errorMessages={['this field is required', 'email is not valid']}
                            helperText={error ? errorText : null}
                            type={"email"}
                            value={email}
                            onChange={(event) => setEmail(event.target.value)}
                            margin="normal"
                            variant="outlined"
                        />
                    </div>
                    <div>
                        <TextValidator
                            error={error}
                            fullWidth
                            disabled={loading}
                            id="outlined-password"
                            label="Password"
                            validators={['required']}
                            errorMessages={['this field is required']}
                            type={"password"}
                            value={password}
                            onChange={(event) => setPassword(event.target.value)}
                            margin="normal"
                            variant="outlined"
                        />
                    </div>
                </ValidatorForm>
            </div>
        </CardContent>
        <CardActions>
            <Button onClick={() => submit()} disabled={loading} color="primary">
                Login
            </Button>

            <Button onClick={() => submit()} disabled={loading} color="secondary">
                Cancel
            </Button>
        </CardActions>
    </Card></div>;
}

function LoginPage(props) {
    return <div><LoginForm/></div>
}

export {LoginForm, LoginPage};